import { PlanningItineraryApp } from "itineraryexport/PlanningItineraryApp";
import { userTypeRouting } from "pages/utils";
import { PlanningMapApp } from "Planning/PlanningMapApp";
import { PlanningMonthExternalApp, PlanningMonthInternalApp } from "Planning/PlanningMonthApp";
import { PlanningQuarterExternalApp, PlanningQuarterInternalApp } from "Planning/PlanningQuarterApp";
import { PlanningWeekApp } from "Planning/PlanningWeekApp";
import { type RouteObject } from "react-router";

declare let viewModel: any;

export const planningRoute: RouteObject = {
  path: "planning",
  children: [{
    path: "month",
    loader: () => viewModel,
    Component: userTypeRouting({
      internal: PlanningMonthInternalApp,
      external: PlanningMonthExternalApp,
    }),
  }, {
    path: "quarter",
    loader: () => viewModel,
    Component: userTypeRouting({
      internal: PlanningQuarterInternalApp,
      external: PlanningQuarterExternalApp,
    }),
  }, {
    path: "week",
    loader: () => viewModel,
    Component: PlanningWeekApp,
  }, {
    path: "map",
    loader: () => viewModel,
    Component: PlanningMapApp,
  }, {
    path: "itinerary",
    loader: () => viewModel,
    Component: PlanningItineraryApp,
  }]
};